<script>
    import { createEventDispatcher } from 'svelte';
    import { link } from "svelte-routing";
    import { deleteUser } from "../../../services/userService";
    import DeleteButton from "../DeleteButton.svelte";
    import toast from "svelte-french-toast";

    const maxCharEmail = 22;
    const maxCharGroup = 15;
    const maxCharName = 40;

    const dispatch = createEventDispatcher();
    export let id;
    export let firstname;
    export let lastname;
    export let email;
    export let role;
    export let group;
    let element = "l'utente";

    async function handleDeleteUser() {
        deleteUser(id).then(() => {
            updateTable();
            toast.success("Utente eliminato");
        }).catch((err) => {
            if(err?.response?.status === 404) {
                toast.error("Utente Non trovato");
            }
        })
    }

    function updateTable() {
        dispatch('delete', { state: "user deleted" });
    }

    async function copyEmail() {
        try {
            await navigator.clipboard.writeText(email);
            toast.success("Email copiata");
        } catch (err) {
            toast.error("Impossibile copiare l'email");
        }
    }

    function sendEmail() {
        window.location.href = `mailto:${email}`;
    }
</script>


<tr class="h-14 border-b">
    <td class="w-1/6 {firstname?.length > maxCharName ? 'scroll-container' : ''}">
        <div class="{firstname?.length > maxCharName ? 'scroll-text' : ''}">
            {firstname ?? ""}
        </div>
    </td>
    <td class="w-1/6 {lastname?.length > maxCharName ? 'scroll-container' : ''}">
        <div class="{lastname?.length > maxCharName ? 'scroll-text' : ''}">
            {lastname ?? ""}
        </div>
    </td>
    <td class="w-1/6 {email.length > maxCharEmail ? 'scroll-container' : ''}">
        {email}

        <i class="fa fa-copy ml-3 text-lightBlue-500 cursor-pointer" on:click={copyEmail}></i>
<!--        <i class="fa fa-share-square ml-3 cursor-pointer" on:click={sendEmail}></i>-->
    </td>
    <td class="w-1/6">
        {role === "GROUP_MANAGER" ? "AMM. DI GRUPPO" : role === "ADMIN" ? "ADMIN" : "UTENTE"}
    </td>
    <td class="w-1/6 {group?.name.length > maxCharGroup ? 'scroll-container' : ''}">
        <div class="{group?.name.length > maxCharGroup ? 'scroll-text' : ''}">
            {group?.name ?? ""}
        </div>
    </td>
    <td class="text-center">
        <a
            use:link
            href="/admin/users/edit?id={id}"
            class="mr-3"
        >
            <span class="w-10 h-10 text-sm border inline-flex items-center justify-center rounded-full cursor-pointer">
                <i class="fa fa-edit"></i>
            </span>
        </a>

        <DeleteButton
            buttonText="Elimina"
            message="Vuoi eliminare l'utente?"
            bind:element={element}
            buttonClass="w-44"
            on:delete={() => handleDeleteUser()}
        />
    </td>
</tr>